"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConvertedFlightDates = exports.calculatePassengersCount = exports.convertKeysToSnakeCase = exports.validateEmail = exports.prepareFlightDetailsData = exports.isTokenExpired = exports.getUTCTimestamp = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const dictionaries_1 = require("./dictionaries");
const lodash_1 = require("lodash");
const getUTCTimestamp = () => {
    return moment_timezone_1.default.utc().valueOf() / 1000;
};
exports.getUTCTimestamp = getUTCTimestamp;
const isTokenExpired = (expirationDate) => {
    // Force generating a new pair of tokens 5 seconds before the expiration date
    const expirationOffset = 5;
    return +expirationDate - expirationOffset < (0, exports.getUTCTimestamp)();
};
exports.isTokenExpired = isTokenExpired;
const prepareFlightDetailsData = (flightData) => {
    const flightTime = (0, moment_timezone_1.default)(flightData.flight_time, "HH:mm:ss").format("HH:mm") + ' h';
    const flightStatus = dictionaries_1.FlightStatus[flightData.status];
    const completedFlightStatus = ["CLOSED", "DONE"];
    const ongoingFlightStatus = ['NEW', "OPEN"];
    const isCompleted = completedFlightStatus.includes(flightStatus);
    const isOngoing = ongoingFlightStatus.includes(flightStatus);
    const isCanceled = flightStatus === 'CANCELED';
    const flightDates = (0, exports.getConvertedFlightDates)(flightData.departure_datetime, flightData.destination_eta);
    const passengersCount = (0, exports.calculatePassengersCount)(flightData.passengers_seats);
    return {
        ...(0, lodash_1.omit)(flightData, ['departure_datetime', 'destination_eta']),
        ...flightDates,
        flightTime,
        isCompleted,
        isOngoing,
        isCanceled,
        passengersCount
    };
};
exports.prepareFlightDetailsData = prepareFlightDetailsData;
const validateEmail = (email) => {
    const emailExpression = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailExpression.test(email);
};
exports.validateEmail = validateEmail;
const camelToSnake = (str) => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
const convertKeysToSnakeCase = (obj) => {
    const result = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const newKey = camelToSnake(key);
            result[newKey] = obj[key];
        }
    }
    return result;
};
exports.convertKeysToSnakeCase = convertKeysToSnakeCase;
const calculatePassengersCount = (passengersSeats) => (0, lodash_1.reduce)(passengersSeats, (result, value) => {
    return result + value;
}, 0);
exports.calculatePassengersCount = calculatePassengersCount;
const getConvertedFlightDates = (departureDatetime, arrivalDateTime) => {
    const localDepartureDatetime = moment_timezone_1.default.utc(departureDatetime).local();
    const localArrivalDateTime = moment_timezone_1.default.utc(arrivalDateTime).local();
    const departureDate = localDepartureDatetime.format('DD.MM.YYYY');
    const departureDateFormatted = localDepartureDatetime.format("ddd., D MMMM");
    const departureTime = localDepartureDatetime.format('HH:mm');
    const arrivalTime = localArrivalDateTime.format('HH:mm');
    return {
        departureDate,
        departureDateFormatted,
        departureTime,
        arrivalTime
    };
};
exports.getConvertedFlightDates = getConvertedFlightDates;
